import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';
import eps from '../pages/prizes/store/eps';
import payments from '../pages/prizes/store/payments';
import banners from '../pages/profile/store/banners';
import surveys from '../pages/profile/store/surveys';
import webpush from '../pages/profile/store/webpush';
import courses from '../pages/courses/store/courses';
import notifications from '../pages/profile/store/notifications';
import mobileNotifications from '../pages/mobileNotifications/store/mobileNotifications';
import sales from '../pages/sales/store/sales';
import news from '../pages/news/store/news';
import tickets from '../pages/tickets/store/tickets';

Vue.use(Vuex);

const baseURL = process.env.NODE_ENV === 'production' ? 'https://api-ricoh2.msforyou.ru' : 'http://ricoh2.f';
const xToken = 'QhgmU5ABkKfD35HpABTs1W-JYzRxMqcILp54fsCFlnO_OUX8Iko6RWGh9zVO-IFa';

const store = new Vuex.Store({
  plugins: [createPersistedState({ key: 'promo', ssr: false })],
  state: {
    loading: false,
    dialogs: {
      surveys: true,
      notifications: true,
    },
    profile_id: null,
    token: null,
    user: null,
    userTransactions: [],
    paymentsInfo: {},
    settings: {},
  },
  mutations: {
    menuSide(state, settings) {
      state.settings.layout = settings;
    },
    SetSettings(state, settings) {
      state.settings = settings;
    },
    SetUser(state, payload) {
      state.user = payload;
    },
    SetDialog(state, payload) {
      state.dialogs[payload.dialog] = payload.value;
    },
    SetUserTransactions(state, payload) {
      state.userTransactions = payload;
    },
    SetLogged(state, payload) {
      state.profile_id = payload.profile_id;
      state.token = payload.token;
    },
    SetLoading(state, payload) {
      state.loading = payload;
    },
    SetPaymentsSettings(state, payload) {
      state.paymentsInfo.methods = payload;
    },
    Logout(state) {
      state.profile_id = null;
      state.user = null;
      state.token = null;
    },
  },
  actions: {
    UnsetError() {
      Vue.notify({ group: 'error', clean: true });
    },
    UnsetInfo() {
      Vue.notify({ group: 'info', clean: true });
    },
    ShowInfo({ dispatch }, message) {
      dispatch('UnsetError');
      dispatch('UnsetInfo');
      dispatch('ShowInfoMessage', message);
    },
    ShowError({ dispatch }, message) {
      dispatch('UnsetError');
      dispatch('UnsetInfo');
      dispatch('ShowErrorMessage', message);
    },
    ShowErrorMessage({}, message) {
      const text = `<i class="v-icon v-icon--left material-icons mr-1" style="vertical-align:bottom">error_outline</i> ${message}`;
      Vue.notify({ group: 'error', type: 'error', text, duration: 60000 });
    },
    ShowInfoMessage({}, message) {
      const text = `<i class="v-icon v-icon--left material-icons mr-1" style="vertical-align:bottom">notifications</i> ${message}`;
      Vue.notify({ group: 'info', type: 'info', text, duration: 7000 });
    },
    HandleError({ dispatch }, error) {
      if (error.response) {
        // Error recieved from the server
        const { data } = error.response;
        let errors = [];
        if ('error' in data) {
          errors = [data.error];
        } else if ('errors' in data) {
          if (Array.isArray(data.errors)) {
            ({ errors } = data);
          } else {
            Object.keys(data.errors).forEach((k) => {
              errors.push(data.errors[k]);
            });
          }
        }
        // maximum show 2 errors
        if (errors.length > 2) {
          errors = errors.slice(0, 2);
        }
        errors.forEach((message) => {
          dispatch('ShowErrorMessage', message);
        });
      } else if (error.request) {
        // The request was made but no response was received
        dispatch('ShowErrorMessage', 'С вашим подключением не все так просто. Пожалуйста, проверьте доступ к интернету');
      } else {
        // Something happened in setting up the request that triggered an Error
        dispatch('ShowErrorMessage', 'Что-то пошло не так');
        console.log(error.config);
      }
    },
    GetSettings({ commit, getters }) {
      getters.ax.post('api/settings')
        .then((response) => {
          commit('SetSettings', response.data.settings);
        });
    },
    GetProfile({ commit, state, getters }) {
      if (state.profile_id) {
        getters.ax.post('profiles/api/auth/get-profile', { profile_id: state.profile_id })
          .then((response) => {
            commit('SetUser', response.data.profile);
          });
      }
    },
    GetTransactions({ commit, state, getters }) {
      if (state.profile_id) {
        getters.ax.post('profiles/api/transaction/list', { profile_id: state.profile_id })
          .then((response) => {
            commit('SetUserTransactions', response.data.transactions);
          });
      }
    },
    GetPaymentsSettings({ commit, state, getters }) {
      if (state.profile_id) {
        getters.ax.post('payments/api-v3/settings/view')
          .then((response) => {
            commit('SetPaymentsSettings', response.data.settings);
          });
      }
    },
    UserLogin({ commit, dispatch }, payload) {
      commit('SetLogged', payload);
      dispatch('ShowInfoMessage', 'Добро пожаловать!');
    },
    UserLogout({ commit, dispatch }) {
      commit('Logout');
      dispatch('eps/ClearCart');
      dispatch('webpush/ResetToken');
      localStorage.clear();
      dispatch('GetSettings');
    },
    DownloadFile({ getters, dispatch }, info) {
      getters.axf.post(info.url, info.data).then((response) => {
        const blob = new Blob([response.data]);
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, info.filename);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', info.filename);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      }).catch((error) => {
        dispatch('HandleError', error);
      });
    },
  },
  getters: {
    ax(state) {
      const ax = axios.create({
        baseURL,
        timeout: 60000,
        headers: { 'Content-Type': 'application/json', 'X-Token': xToken },
      });
      ax.interceptors.request.use(
        (config) => {
          if (state.token !== undefined && state.token) {
            config.headers.Authorization = `Bearer ${state.token}`;
          }
          return config;
        },
        error => Promise.reject(error),
      );
      return ax;
    },
    axl(state) {
      const ax = axios.create({
        baseURL,
        timeout: 60000,
        headers: { 'Content-Type': 'application/json', 'X-Token': xToken },
      });
      ax.interceptors.request.use(
        (config) => {
          if (state.token !== undefined && state.token) {
            config.headers.Authorization = `Bearer ${state.token}`;
          }
          state.loading = true;
          return config;
        },
        error => Promise.reject(error),
      );
      ax.interceptors.response.use(
        (response) => {
          state.loading = false;
          Vue.notify({ group: 'error', clean: true });
          return response;
        },
        (error) => {
          state.loading = false;
          Vue.notify({ group: 'error', clean: true });
          return Promise.reject(error);
        },
      );
      return ax;
    },
    axf(state) {
      const ax = axios.create({
        baseURL,
        timeout: 60000,
        headers: { 'Content-Type': 'application/json', 'X-Token': xToken },
        responseType: 'blob',
      });
      ax.interceptors.request.use(
        (config) => {
          if (state.token !== undefined && state.token) {
            config.headers.Authorization = `Bearer ${state.token}`;
          }
          state.loading = true;
          return config;
        },
        error => Promise.reject(error),
      );
      ax.interceptors.response.use(
        (response) => {
          state.loading = false;
          Vue.notify({ group: 'error', clean: true });
          return response;
        },
        (error) => {
          state.loading = false;
          Vue.notify({ group: 'error', clean: true });
          return Promise.reject(error);
        },
      );
      return ax;
    },
    token(state) {
      return state.token;
    },
    isAuthenticated(state) {
      return state.profile_id !== null && state.profile_id !== undefined
        && state.token !== null && state.token !== undefined;
    },
  },
  modules: {
    courses,
    eps,
    payments,
    surveys,
    notifications,
    mobileNotifications,
    sales,
    news,
    tickets,
    banners,
    webpush,
  },
});

export default store;
